import React, { useEffect, useMemo, useState } from "react";
import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, Select, Input, Switch, Button, HStack, VStack, useToast } from "@chakra-ui/react";
import client from "../../../helpers/Client";

const ROLE_OPTIONS = [
  { value: "superuser", label: "Superuser" },
  { value: "manager", label: "Yönetici" },
  { value: "servicer", label: "Servisçi" },
  { value: "technical", label: "Teknik" },
  { value: "reseller", label: "Bayi" },
  { value: "employee", label: "Personel" },
];

export default function AdminRolePages() {
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState("manager");
  const [search, setSearch] = useState("");
  const [newItem, setNewItem] = useState({ route: "", label: "", enabled: true });

  const fetchItems = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (role) params.set("role_code", role);
      if (search) params.set("search", search);
      const { data } = await client.get(`/config/role-pages/?${params.toString()}`);
      const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
      setItems(arr);
    } catch (e) {
      toast({ title: "Liste alınamadı", status: "error" });
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchItems(); }, [role, search]);

  const handleToggle = async (it) => {
    try {
      await client.patch(`/config/role-pages/${it.id}/`, { enabled: !it.enabled });
      toast({ title: !it.enabled ? "Açıldı" : "Kapatıldı", status: "success" });
      fetchItems();
    } catch (e) {
      toast({ title: "Güncelleme hatası", status: "error" });
    }
  };

  const handleAdd = async () => {
    if (!newItem.route) { toast({ title: "Route gerekli", status: "warning" }); return; }
    try {
      await client.post(`/config/role-pages/`, { role_code: role, ...newItem });
      setNewItem({ route: "", label: "", enabled: true });
      toast({ title: "Eklendi", status: "success" });
      fetchItems();
    } catch (e) {
      toast({ title: "Ekleme hatası", status: "error" });
    }
  };

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>Rol → Sayfa Erişimleri</Heading>
      <HStack mb={4} spacing={3}>
        <Select value={role} onChange={(e) => setRole(e.target.value)} w="220px">
          {ROLE_OPTIONS.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
        </Select>
        <Input placeholder="Route/etiket ara" value={search} onChange={(e) => setSearch(e.target.value)} />
      </HStack>

      <VStack align="stretch" spacing={3} mb={4}>
        <HStack>
          <Input placeholder="/admin/kullanicilar/" value={newItem.route} onChange={(e) => setNewItem({ ...newItem, route: e.target.value })} />
          <Input placeholder="Etiket (opsiyonel)" value={newItem.label} onChange={(e) => setNewItem({ ...newItem, label: e.target.value })} />
          <HStack>
            <span>Açık</span>
            <Switch isChecked={newItem.enabled} onChange={(e) => setNewItem({ ...newItem, enabled: e.target.checked })} />
          </HStack>
          <Button colorScheme="green" onClick={handleAdd}>Ekle</Button>
        </HStack>
      </VStack>

      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Route</Th>
            <Th>Etiket</Th>
            <Th>Durum</Th>
            <Th>Aksiyon</Th>
          </Tr>
        </Thead>
        <Tbody>
          {items.map(it => (
            <Tr key={it.id}>
              <Td>{it.route}</Td>
              <Td>{it.label || "-"}</Td>
              <Td>{it.enabled ? "Açık" : "Kapalı"}</Td>
              <Td>
                <Button size="sm" onClick={() => handleToggle(it)}>{it.enabled ? "Kapat" : "Aç"}</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}